export const GoogleCalendarGetters = {
  googleCalendarInfo: state => state.calendarInfo,
  googleCalendarSyncProgress: state => state.calendarInfo.sync?.progress || 0,
  isGoogleCalendarAccessible: state => state.calendarInfo.accessible,
  isGoogleCalendarConfigured: state => !!state.calendarInfo.id,
  isGoogleCalendarLinked: state => state.calendarInfo.linked,
  isGoogleCalendarSyncing: state => state.calendarInfo.sync?.running,
}
